// Import Packages
import React, { useRef, useState, useEffect } from "react";
import MultiCrops from "react-multi-crops";
import Xarrow from "react-xarrows";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from 'uuid';

// Import MaterialUi
import Close from "@material-ui/icons/Close";

// Import Helpers
import * as helper from "../../helpers/helper";

// Import Services
import automService from "../../services/AutomService/AutomService";

// Import Css
import './CaptureArea.css';

// Import Pages
import RightArea from '../FlowConfigurationForms';
import DeleteConfirm from "../DataTable/DeleteConfirm";
import SquareHighlight from "../SquareHighlight/SquareHighlight";
import ElementsHighlight from "../ElementsHighlight/ElementsHighlight";
import VariableAssign from "../FlowConfigurationForms/Ocr/CaptureTextFromImage/VariableAssign";
import { useSetRecoilState } from "recoil";
import { alertState } from "../../recoil-store/recoil-state";
import { generateRandomString } from "../../helpers/helper";
import RunningModal from "../../home/pages/automs/autom/component/RunningModal";
import HighlightAreaConfiguration from "./HightlightAreaConfiguration/HighlightAreaConfiguration";
import Guide from "./Guide/Guide";


/**
 * @description this page Cropped image assign variable
 * @param       action - object
 * @param       previewCanvasRef - cropping canvas reference
 * @param       setOpenCaptureArea - open capture area function
 * @param       upImg - uploading image
 * @returns     canvas reference
 * @author      Onur DOGUCU
 */

const CaptureArea = ({
    setOpenCaptureArea,
    upImg,
    action,
    setOpenVariable,
    variables,
    isGrid,
    isVariableShow = true,
    isFindAndInput = false,
    isGetText = false,
    handleScale,
    imageEnlarged,
    actions,
    setVariables,
    recorder,
    drecorder,
    getVariables,
    handleCloseDialog,
    items,
    automDetail,
    setAutomDetail,
    paginationArea,
    setPaginationArea,
    uniqueColumnAreas,
    setUniqueColumnAreas,
    activeAreaSelector
}) => {

    const [index, setIndex] = useState(0);
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [clickedCoordinates, setClickedCoordinates] = useState({});
    const [editAreaCoordinates, setEditAreaCoordinates] = useState({});
    const refSource = useRef(null);
    const refDestination = useRef(null);
    const [refresh, setRefresh] = useState(false);
    const [openInputModal, setOpenInputModal] = useState(false);
    const [showSquareHighlight, setShowSquareHighlight] = useState(false);
    const [squareHighlightValues, setSquareHighlightValues] = useState({
        clickObj: [0, 0, 0, 0],
        neighbourObj: [0, 0, 0, 0]
    });
    const [showElementsHighlight, setShowElementsHighlight] = useState(false);
    const [openHighlightModal, setOpenHighlightModal] = useState(false);
    const [elementsValue, setElementsValue] = useState({});
    const [imgCoordinate, setImgCoordinate] = useState({ coordinates: [] });
    const [paginationCoordinate, setPaginationCoordinate] = useState([]);
    const [uniqueColumnCoordinates, setUniqueColumnCoordinates] = useState([]);
    const [flowStatus, setFlowStatus] = useState(0);
    const [openRunningModal, setOpenRunningModal] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [operationId, setOperationId] = useState("");
    const refGetTextImage = useRef(null);
    const containerAreaRef = useRef(null);
    let control = action.fields.source?.value?.x > 0;
    const setAlert = useSetRecoilState(alertState);
    const label = "CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.FIND-AND-CLICK.";
    const { t } = useTranslation();

    useEffect(() => {
        if (action.actionName === 'GET-TEXT' || action.actionName === 'PAGINATION-ITEM' || action.actionName === 'CROP-IMAGE') {
            if (action.fields?.completedCropOffset?.value) {
                setImgCoordinate({ coordinates: action.fields?.completedCropOffset?.value });
            }

            if (!action.fields.set?.value) {
                setTimeout(() => {
                    showRightAreaOnCenterPage();
                }, 1000)
            }
        }
    }, [action.id]);

    useEffect(() => {
        setTimeout(() => {
            if (refSource.current) {
                if (
                    isVariableShow === false &&
                    action.fields.completedCrop?.value.length === 1 &&
                    action.fields.source?.value?.x > 0
                ) {
                    let sourceDiv = document.getElementById("source-click-div");
                    //draw line and coordinate
                    sourceDiv.style.position = "absolute";
                    sourceDiv.style.left =
                        Number(action.fields.source.value.x) + 16 + "px";
                    sourceDiv.style.top =
                        Number(action.fields.source.value.y) + 48 + "px";
                    sourceDiv.style.background = "red";
                    sourceDiv.style.width = 5 + "px";
                    sourceDiv.style.height = 5 + "px";
                    sourceDiv.style.zIndex = "99999";
                }
                if (
                    isVariableShow === false &&
                    action.fields.destination?.value?.x > 0 &&
                    action.fields.completedCrop.value.length === 1
                ) {
                    let destinationDiv = document.getElementById("destination-click-div");
                    //draw line and coordinate

                    destinationDiv.style.position = "absolute";
                    destinationDiv.style.left =
                        action.fields.destination?.value?.x + "px";
                    destinationDiv.style.top = action.fields.destination?.value?.y + "px";
                    destinationDiv.style.background = "red";
                    destinationDiv.style.width = 5 + "px";
                    destinationDiv.style.height = 5 + "px";
                    destinationDiv.style.zIndex = "99999";
                }
                setRefresh(!refresh);
            }
        }, 500);

        if (action.actionName === "FIND-AND-CLICK" ||
            action.actionName === "FIND-AND-INPUT" ||
            action.actionName === "PAGINATION" ||
            action.actionName === "HOVER" ||
            action.actionName === "ELEMENT-EXIST" ||
            action.actionName === "SMOOTH-SCROLL") {
            checkAndShowElements()
        }

        // else if (action.actionName === "FIND-AND-INPUT" && action.fields.destination?.value.x) {
        //     const selectedAreaDot = document.querySelector(".hidden-dot")
        //     const selectedAreaConfig = document.querySelector(".select-configuration")
        //     selectedAreaDot.style.display = "inline-block"
        //     const x = action.fields.destination.value.x
        //     const y = action.fields.destination.value.y
        //     selectedAreaDot.style.left = (x - 11) + "px"
        //     selectedAreaDot.style.top = (y - 11) + "px"
        //     selectedAreaConfig.style.display = "inline-block"
        //     selectedAreaConfig.style.left = (x + 20) + "px"
        //     selectedAreaConfig.style.top = (y - 11) + "px"
        // }
    }, []);


    //key press event
    function handleKeyEvent(event) {
        if (event.key === "Enter") {
            setOpen(true);
        }
    }

    const checkAndShowElements = async () => {
        let tmpActions = JSON.parse(JSON.stringify(actions))
        helper.updateFlowItems(items, tmpActions, tmpActions)
        let scopeItem = await helper.findParentScopeById(action.item_id, items, true)
        if (scopeItem) {
            if (scopeItem.fields.highlightElements?.value) {
                resizeElements(scopeItem.fields.highlightElements.value, scopeItem)
            }
        }
    }

    const resizeElements = async (responseDataJson, scopeItem) => {
        const image = new Image();
        image.src = upImg ? upImg : scopeItem.fields?.getSS?.value;
        // Scale Configuration

        const elementsHighlightInterval = setInterval(() => {
            // Function for all calculating elements width, height and position in CaptureArea
            const originalWidth = image.width;
            const originalHeight = image.height;
            const element = document.querySelector(".find-and-click-image-container");
            const rescaledWidth = document.getElementById("scoped-image").offsetWidth;
            const rescaledHeight = document.getElementById("scoped-image").offsetHeight;
            if (element) {
                const width = element.offsetWidth
                const height = element.offsetHeight
                // Checking image width and height is maxed and ready for elements.
                if (width === rescaledWidth && height === rescaledHeight) {
                    clearInterval(elementsHighlightInterval)

                    if (responseDataJson.elements && responseDataJson.elements.hasOwnProperty("label") && responseDataJson.elements.label.length > 0) {
                        const elements = [];
                        let i = 0;

                        for (let item of responseDataJson.elements.label) {
                            if (item !== "negative") {
                                const originalLeft = responseDataJson.elements.box[i][0]; // Left coordinate of the part you want to draw
                                const originalTop = responseDataJson.elements.box[i][1]; // Top coordinate of the part you want to draw
                                const originalPartWidth = responseDataJson.elements.box[i][2]; // Width of the part you want to draw
                                const originalPartHeight = responseDataJson.elements.box[i][3]; // Height of the part you want to draw
                                const widthScale = rescaledWidth / originalWidth;
                                const heightScale = rescaledHeight / originalHeight;
                                // Calculate the resized coordinates and dimensions
                                const resizedLeft = originalLeft * widthScale;
                                const resizedTop = originalTop * heightScale;
                                const resizedPartWidth = originalPartWidth * widthScale;
                                const resizedPartHeight = originalPartHeight * heightScale;
                                responseDataJson.elements.box[i][0] = resizedLeft
                                responseDataJson.elements.box[i][1] = resizedTop
                                responseDataJson.elements.box[i][2] = resizedPartWidth
                                responseDataJson.elements.box[i][3] = resizedPartHeight
                                elements.push({ label: item, coordinate: responseDataJson.elements.box[i] })
                            }
                            i++;
                        }
                        if (action.fields.highlightedElements?.value?.clickedObj?.length && action.fields.highlightedElements?.value?.neighbourObj?.length) {

                            const oldRescaledWidth = action.fields.highlightedElements?.value?.rescaledWidth
                            const oldRescaledHeight = action.fields.highlightedElements?.value?.rescaledHeight
                            if ((oldRescaledWidth || oldRescaledHeight) && (oldRescaledWidth !== rescaledWidth || oldRescaledHeight !== rescaledHeight)) {
                                const clickedObject = action.fields.highlightedElements?.value?.clickedObj
                                const neighborObject = action.fields.highlightedElements?.value?.neighbourObj
                                const originalLeft = clickedObject[0]; // Left coordinate of the part you want to draw
                                const originalTop = clickedObject[1]; // Top coordinate of the part you want to draw
                                const originalPartWidth = clickedObject[2]; // Width of the part you want to draw
                                const originalPartHeight = clickedObject[3]; // Height of the part you want to draw
                                // Calculate scaling factors
                                const widthScale = rescaledWidth / oldRescaledWidth;
                                const heightScale = rescaledHeight / oldRescaledHeight;
                                // Calculate the resized coordinates and dimensions
                                const resizedLeft = originalLeft * widthScale;
                                const resizedTop = originalTop * heightScale;
                                const resizedPartWidth = originalPartWidth * widthScale;
                                const resizedPartHeight = originalPartHeight * heightScale;
                                clickedObject[0] = resizedLeft
                                clickedObject[1] = resizedTop
                                clickedObject[2] = resizedPartWidth
                                clickedObject[3] = resizedPartHeight
                                const originalLeft1 = neighborObject[0]; // Left coordinate of the part you want to draw
                                const originalTop1 = neighborObject[1]; // Top coordinate of the part you want to draw
                                const originalPartWidth1 = neighborObject[2]; // Width of the part you want to draw
                                const originalPartHeight1 = neighborObject[3]; // Height of the part you want to draw
                                // Calculate scaling factors
                                const widthScale1 = rescaledWidth / oldRescaledWidth;
                                const heightScale1 = rescaledHeight / oldRescaledHeight;
                                // Calculate the resized coordinates and dimensions
                                const resizedLeft1 = originalLeft1 * widthScale;
                                const resizedTop1 = originalTop1 * heightScale;
                                const resizedPartWidth1 = originalPartWidth1 * widthScale1;
                                const resizedPartHeight1 = originalPartHeight1 * heightScale1;
                                neighborObject[0] = resizedLeft1
                                neighborObject[1] = resizedTop1
                                neighborObject[2] = resizedPartWidth1
                                neighborObject[3] = resizedPartHeight1

                                const positionData = {
                                    clickObj: clickedObject,
                                    neighbourObj: neighborObject
                                }
                                action.fields.highlightedElements.value = { clickedObj: clickedObject, neighbourObj: neighborObject, rescaledWidth, rescaledHeight };
                                setSquareHighlightValues(positionData);
                            }
                            else if (!oldRescaledWidth && !oldRescaledHeight) {
                                action.fields.highlightedElements.value = { ...action.fields.highlightedElements.value, rescaledWidth, rescaledHeight }
                            }
                            else {
                                setSquareHighlightValues({
                                    clickObj: action.fields.highlightedElements.value.clickedObj,
                                    neighbourObj: action.fields.highlightedElements.value.neighbourObj,
                                });
                            }
                            // calculating arrow beetween clicked area and neighbor area
                            const clickX = action.fields.highlightedElements.value.clickedObj[0] - action.fields.highlightedElements.value.neighbourObj[0];
                            const clickY = action.fields.highlightedElements.value.clickedObj[1] - action.fields.highlightedElements.value.neighbourObj[1]
                            if (Math.abs(clickX) > 50 || Math.abs(clickY) > 50) {
                                const startDiv = document.getElementById("source-click-div")
                                const endDiv = document.getElementById("destination-click-div")
                                startDiv.style.left = action.fields.highlightedElements.value.clickedObj[0] + "px"
                                startDiv.style.top = action.fields.highlightedElements.value.clickedObj[1] + "px"
                                startDiv.style.display = "block"

                                endDiv.style.left = action.fields.highlightedElements.value.neighbourObj[0] + "px"
                                endDiv.style.top = action.fields.highlightedElements.value.neighbourObj[1] + "px"
                                endDiv.style.display = "block"
                            }

                            setShowSquareHighlight(true);
                        }
                        setElementsValue(elements);
                        setShowElementsHighlight(true);
                    }
                }
            }
        }, 400);

    }

    const handleClickedArea = (event, left, top) => {
        // Find the click point of current image
        const rect = event.target.getBoundingClientRect();
        let clickedX = (event.clientX) - rect.left;
        let clickedY = (event.clientY) - rect.top;
        if (left || top) {
            clickedX += left
            clickedY += top
        }
        // document click circle and configuration div and give them styles
        const selectedAreaDot = document.querySelector(".hidden-dot")
        const selectedAreaConfig = document.querySelector(".select-configuration")
        const rescaledWidth = document.getElementById("scoped-image").offsetWidth;
        const rescaledHeight = document.getElementById("scoped-image").offsetHeight;
        selectedAreaConfig.style.display = "inline-block"

        if (selectedAreaConfig.offsetWidth + clickedX + 20 < rescaledWidth) {
            selectedAreaConfig.style.left = (clickedX + 20) + "px"
        }
        else {
            selectedAreaConfig.style.left = (clickedX - 20 - selectedAreaConfig.offsetWidth) + "px"
        }
        if (selectedAreaConfig.offsetHeight + clickedY + 11 < rescaledHeight) {
            selectedAreaConfig.style.top = (clickedY - 11) + "px"
        }
        else {
            selectedAreaConfig.style.top = (clickedY - 11 - selectedAreaConfig.offsetHeight) + "px"
        }
        selectedAreaDot.style.left = (clickedX - 11) + "px"
        selectedAreaDot.style.top = (clickedY - 11) + "px"
        selectedAreaDot.style.display = "inline-block"


        // Prepare set state for handleClicked function
        setClickedCoordinates({ x: clickedX, y: clickedY, targetId: event.target.id, targetNodeName: event.target.nodeName })
        setIsEdit(false)
        setRefresh((pre) => !pre)
    }

    async function handleClicked() {
        // if (clickedCoordinates.targetId === "destination-click-div" && isFindAndInput === true) {
        //     setOpenInputModal(true);
        // }
        if (clickedCoordinates.targetNodeName === "IMG" || clickedCoordinates.targetNodeName === "DIV") {
            if (isVariableShow === true && isGetText === false) {
                setOpen(true);
            } else {
                if (
                    isVariableShow === false
                ) {
                    setFlowStatus(0)
                    setOpenRunningModal(true);
                    let isReponseSuccess = false;
                    let operation_id = uuidv4();
                    setOperationId(operation_id);
                    setTimeout(() => {
                        if (!isReponseSuccess) {
                            setFlowStatus(4);
                        }
                    }, 30000)
                    // action.fields.source.value = { x: clickedX, y: clickedY };
                    // action.fields.orjinalSource.value = { x: originalX, y: originalY };
                    action.fields.imgURL.value = upImg;

                    const image = new Image();
                    image.src = upImg;

                    // Scale Configuration
                    const originalWidth = image.width;
                    const originalHeight = image.height;

                    const rescaledWidth = document.getElementById("scoped-image").offsetWidth;
                    const rescaledHeight = document.getElementById("scoped-image").offsetHeight;

                    const selectedAreaDot = document.querySelector(".hidden-dot")
                    const selectedAreaConfig = document.querySelector(".select-configuration")
                    selectedAreaDot.style.display = "none"
                    selectedAreaConfig.style.display = "none"

                    const scaleX = originalWidth / rescaledWidth;
                    const scaleY = originalHeight / rescaledHeight;

                    const originalX = Math.round(clickedCoordinates.x * scaleX);
                    const originalY = Math.round(clickedCoordinates.y * scaleY);

                    action.fields.source.value = { x: originalX, y: originalY };
                    action.fields.resolution.value = { width: image.width, height: image.height }
                    action.fields.elements = { value: false }
                    const tmpAction = JSON.parse(JSON.stringify(action));
                    tmpAction.mate_id = automDetail.mate_id;
                    let newFindAndInput;
                    if (action.actionName === "FIND-AND-INPUT") {
                        newFindAndInput = JSON.parse(JSON.stringify(action))
                        newFindAndInput.fields.inputValue = { value: "" }
                        newFindAndInput.mate_id = automDetail.mate_id;
                    }
                    const response = await automService.getClickedArea({ action: newFindAndInput ? newFindAndInput : action, operationId: operation_id });

                    const responseData = response.dataString
                    if (responseData) {
                        isReponseSuccess = true;;
                        setFlowStatus(1)
                        setOpenRunningModal(false);
                        const responseDataJson = JSON.parse(responseData);

                        // Set cropping image depends on the actions
                        let cropX = responseDataJson["unique_neighbor"][0];
                        let cropY = responseDataJson["unique_neighbor"][1];
                        let cropWidth = responseDataJson["unique_neighbor"][2];
                        let cropHeight = responseDataJson["unique_neighbor"][3];
                        if (action.actionName === "ELEMENT-EXIST") {
                            cropX = responseDataJson["click_obj"][0];
                            cropY = responseDataJson["click_obj"][1];
                            cropWidth = responseDataJson["click_obj"][2];
                            cropHeight = responseDataJson["click_obj"][3];
                        }

                        await helper.extractAreaAsBase64FromImage(upImg, cropX, cropY, cropWidth, cropHeight)
                            .then(base64CroppedImage => {
                                action.fields.cropImg = {
                                    byteValue: base64CroppedImage,
                                    value: '',
                                    extension: '',
                                    type: "FILE",
                                    fileSize: 0,
                                };
                                //action.fields.cropImg = { value: base64CroppedImage };
                            })
                        setEditAreaCoordinates({ x: clickedCoordinates.x, y: clickedCoordinates.y })
                        // Calculate difference between unique neighbour and clicked area
                        const differenceX = responseDataJson["unique_neighbor"][0] - originalX;
                        const differenceY = responseDataJson["unique_neighbor"][1] - originalY;
                        // const differenceX = responseDataJson["unique_neighbor"][0] - responseDataJson["click_obj"][0];
                        // const differenceY = responseDataJson["unique_neighbor"][1] - responseDataJson["click_obj"][1];
                        action.fields.difference.value = { x: differenceX, y: differenceY };

                        const originalLeft = responseDataJson["click_obj"][0]; // Left coordinate of the part you want to draw
                        const originalTop = responseDataJson["click_obj"][1]; // Top coordinate of the part you want to draw
                        const originalPartWidth = responseDataJson["click_obj"][2]; // Width of the part you want to draw
                        const originalPartHeight = responseDataJson["click_obj"][3]; // Height of the part you want to draw
                        // Calculate scaling factors
                        const widthScale = rescaledWidth / originalWidth;
                        const heightScale = rescaledHeight / originalHeight;
                        // Calculate the resized coordinates and dimensions
                        const resizedLeft = originalLeft * widthScale;
                        const resizedTop = originalTop * heightScale;
                        const resizedPartWidth = originalPartWidth * widthScale;
                        const resizedPartHeight = originalPartHeight * heightScale;
                        responseDataJson["click_obj"][0] = resizedLeft
                        responseDataJson["click_obj"][1] = resizedTop
                        responseDataJson["click_obj"][2] = resizedPartWidth
                        responseDataJson["click_obj"][3] = resizedPartHeight
                        const originalLeft1 = responseDataJson["unique_neighbor"][0]; // Left coordinate of the part you want to draw
                        const originalTop1 = responseDataJson["unique_neighbor"][1]; // Top coordinate of the part you want to draw
                        const originalPartWidth1 = responseDataJson["unique_neighbor"][2]; // Width of the part you want to draw
                        const originalPartHeight1 = responseDataJson["unique_neighbor"][3]; // Height of the part you want to draw
                        // Calculate scaling factors
                        const widthScale1 = rescaledWidth / originalWidth;
                        const heightScale1 = rescaledHeight / originalHeight;
                        // Calculate the resized coordinates and dimensions
                        const resizedLeft1 = originalLeft1 * widthScale;
                        const resizedTop1 = originalTop1 * heightScale;
                        const resizedPartWidth1 = originalPartWidth1 * widthScale1;
                        const resizedPartHeight1 = originalPartHeight1 * heightScale1;
                        responseDataJson["unique_neighbor"][0] = resizedLeft1
                        responseDataJson["unique_neighbor"][1] = resizedTop1
                        responseDataJson["unique_neighbor"][2] = resizedPartWidth1
                        responseDataJson["unique_neighbor"][3] = resizedPartHeight1

                        // clicked obj and neighbor obj is defined
                        const positionData = {
                            clickObj: responseDataJson["click_obj"],
                            neighbourObj: responseDataJson["unique_neighbor"]
                        }

                        // clickable objects defined to ElementsValue State
                        if (responseDataJson.elements && responseDataJson.elements.hasOwnProperty("label") && responseDataJson.elements.label.length > 0) {
                            const elements = [];
                            let i = 0;
                            for (let item of responseDataJson.elements.label) {
                                if (item !== "negative") {
                                    const originalLeft = responseDataJson.elements.box[i][0]; // Left coordinate of the part you want to draw
                                    const originalTop = responseDataJson.elements.box[i][1]; // Top coordinate of the part you want to draw
                                    const originalPartWidth = responseDataJson.elements.box[i][2]; // Width of the part you want to draw
                                    const originalPartHeight = responseDataJson.elements.box[i][3]; // Height of the part you want to draw
                                    // Calculate scaling factors
                                    const widthScale = rescaledWidth / originalWidth;
                                    const heightScale = rescaledHeight / originalHeight;
                                    // Calculate the resized coordinates and dimensions
                                    const resizedLeft = originalLeft * widthScale;
                                    const resizedTop = originalTop * heightScale;
                                    const resizedPartWidth = originalPartWidth * widthScale;
                                    const resizedPartHeight = originalPartHeight * heightScale;
                                    responseDataJson.elements.box[i][0] = resizedLeft
                                    responseDataJson.elements.box[i][1] = resizedTop
                                    responseDataJson.elements.box[i][2] = resizedPartWidth
                                    responseDataJson.elements.box[i][3] = resizedPartHeight
                                    elements.push({ label: item, coordinate: responseDataJson.elements.box[i] })
                                }
                                i++;
                            }

                            setElementsValue(elements);
                            setShowElementsHighlight(true);
                        }
                        action.fields.highlightedElements.value = { clickedObj: responseDataJson["click_obj"], neighbourObj: responseDataJson["unique_neighbor"], rescaledWidth, rescaledHeight };

                        const arrowLongX = responseDataJson["unique_neighbor"][0] - clickedCoordinates.x
                        const arrowLongy = responseDataJson["unique_neighbor"][1] - clickedCoordinates.y

                        const startDiv = document.getElementById("source-click-div")
                        const endDiv = document.getElementById("destination-click-div")
                        if (Math.abs(arrowLongX) > 50 || Math.abs(arrowLongy) > 50) {
                            startDiv.style.left = clickedCoordinates.x + "px"
                            startDiv.style.top = clickedCoordinates.y + "px"
                            startDiv.style.display = "block"
                            endDiv.style.left = responseDataJson["unique_neighbor"][0] + "px"
                            endDiv.style.top = responseDataJson["unique_neighbor"][1] + "px"
                            endDiv.style.display = "block"
                        }
                        else {
                            startDiv.style.display = "none"
                            endDiv.style.display = "none"
                        }

                        setSquareHighlightValues(positionData);
                        setShowSquareHighlight(true);
                    } else if (response && !response.status) {
                        if (response.message !== 'SHUTDOWN-ACTION-SESSIONS') {
                            setAlert(alert => ({
                                ...alert,
                                show: true,
                                message: t("MESSAGES.AUTOMS.DESKTOP-RECORDER.CLICKED-AREA-NOT-FOUND"),
                                severity: 'error'
                            }))
                            setOpenRunningModal(false);
                            setFlowStatus(2);
                        }
                    } else {
                        setAlert(alert => ({
                            ...alert,
                            show: true,
                            message: t("GENERAL.NETWORK-ERROR"),
                            severity: 'error'
                        }))
                        setOpenRunningModal(false);
                        setFlowStatus(2);
                    }

                    // let sourceDiv = document.getElementById("source-click-div");
                    //
                    // //draw line and coordinate
                    // sourceDiv.style.position = "absolute";
                    // sourceDiv.style.left =
                    //     Number(action.fields.completedCrop.value[0].x) + 16 + "px";
                    // sourceDiv.style.top =
                    //     Number(action.fields.completedCrop.value[0].y) + 68 + "px";
                    // sourceDiv.style.background = "red";
                    // sourceDiv.style.width = 5 + "px";
                    // sourceDiv.style.height = 5 + "px";
                    // sourceDiv.style.zIndex = "99999";
                    // control = true;
                }
            }
        }
    }

    async function handleSave() {
        switch (action.actionName) {
            case "FIND-AND-CLICK":
            case "ELEMENT-EXIST":
                if (isEdit) {
                    handleCloseSelectArea()
                    return
                }
                const selectedFACArea = document.querySelector(".selected-area")
                if (selectedFACArea) {
                    setOpenDelete(true)
                    return
                }
                await handleClicked();
                break;
            case "FIND-AND-INPUT":
                if (isEdit) {
                    handleCloseSelectArea()
                    return
                }
                const selectedInput = document.querySelector(".selected-area")
                if (selectedInput) {
                    setOpenDelete(true)
                    return
                }
                await handleClicked();
                break;
            case "PAGINATION":
            case "HOVER":
            case "SMOOTH-SCROLL":
                if (isEdit) {
                    handleCloseSelectArea()
                    return
                }
                const selectedArea = document.querySelector(".selected-area")
                if (selectedArea) {
                    setOpenDelete(true)
                    return
                }
                await handleClicked();
                break;
            case "GET-TEXT":
            case "CROP-IMAGE":
            case "PAGINATION-ITEM":
                handleCloseSelectArea()
                break;
            default:
                break;
        }
    }
    // async function handleClickedOld(event) {
    //     debugger;
    //     if (event.target.id === "destination-click-div" && isFindAndInput === true) {
    //         setOpenInputModal(true);
    //     }

    //     if (event.target.nodeName === "IMG") {
    //         if (isVariableShow === true && isGetText === false) {
    //             setOpen(true);
    //         } else {
    //             if (
    //                 isVariableShow === false
    //             ) {
    //                 const clickedX = event.clientX;
    //                 const clickedY = event.clientY - 68;
    //                 const selectedAreaDot = document.querySelector(".hidden-dot")

    //                 action.fields.source.value = { x: clickedX, y: clickedY };
    //                 action.fields.imgURL.value = upImg;

    //                 const image = new Image();
    //                 image.src = upImg;
    //                 action.fields.resolution.value = { width: image.width, height: image.height }
    //                 const response = await automService.getClickedArea(action);
    //                 const responseData = response.dataString
    //                 if (responseData) {
    //                     const responseDataJson = JSON.parse(responseData);
    //                     const positionData = {
    //                         clickObj: responseDataJson["click_obj"],
    //                         neighbourObj: responseDataJson["unique_neighbor"]
    //                     }

    //                     if (responseDataJson.elements && responseDataJson.elements.hasOwnProperty("label") && responseDataJson.elements.label.length > 0) {
    //                         const elements = [];
    //                         let i = 0;
    //                         for (let item of responseDataJson.elements.label) {
    //                             if (item !== "negative") {
    //                                 elements.push({ label: item, coordinate: responseDataJson.elements.box[i] })
    //                             }
    //                             i++;
    //                         }

    //                         setElementsValue(elements);
    //                         setShowElementsHighlight(true);
    //                     }
    //                     setSquareHighlightValues(positionData);
    //                     setShowSquareHighlight(true);
    //                 }
    //             }
    //         }
    //     }
    // }

    const handleChangeClickArea = (e, left, top, width, heigt, clickInProgress) => {
        setSquareHighlightValues((prev) => ({
            ...prev,
            clickObj: [left, top, width, heigt]
        }));
        action.fields.highlightedElements.value.clickedObj = [left, top, width, heigt];
        saveNewClickedAreaSize(left, top, width, heigt)
    }
    const handleChangeNeighborArea = (e, left, top, width, heigt) => {
        e.preventDefault();
        setSquareHighlightValues((prev) => ({
            ...prev,
            neighbourObj: [left, top, width, heigt]
        }));
        action.fields.highlightedElements.value.neighbourObj = [left, top, width, heigt];
        saveNewNeighborSize(left, top, width, heigt)
    }

    function handleDraw(event) {

        if (event.target.nodeName === "IMG") {
            if (
                isVariableShow === false &&
                control === true &&
                action.fields.source?.value?.x > 0
            ) {
                const popupImg = document.getElementById("popupImg")
                const positionInfoImg = popupImg.getBoundingClientRect();
                const differX = positionInfoImg.x;
                const differY = 60;
                const mainDiv = document.getElementById("capture-area")

                // draw line and coordinate
                let destinationDiv = document.getElementById("destination-click-div");
                destinationDiv.style.position = "absolute";
                destinationDiv.style.left = (event.clientX + mainDiv.scrollLeft) + "px";
                destinationDiv.style.top = (event.clientY + mainDiv.scrollTop) + "px";
                destinationDiv.style.background = "red";
                destinationDiv.style.width = 5 + "px";
                destinationDiv.style.height = 5 + "px";
                destinationDiv.style.zIndex = "99999";
                // Just setting destination value, not related with calculating difference
                action.fields.destination.value.x = event.clientX;
                action.fields.destination.value.y = event.clientY + mainDiv.scrollTop;
                // Calculating difference by using cropped area's position and destination's position, additionally differ with the modal padding values
                let xDifference =
                    action.fields.completedCrop.value[0]?.x - (event.clientX) + differX;
                let yDifference =
                    action.fields.completedCrop.value[0]?.y - (event.clientY + mainDiv.scrollTop) + differY;

                action.fields.difference.value = {
                    x: Math.round(xDifference),
                    y: Math.round(yDifference),
                };
                if (
                    isVariableShow === false &&
                    isFindAndInput === true &&
                    action.fields.source?.value?.x > 0
                ) {
                    setOpenInputModal(true);
                }
                setRefresh(!refresh);
                control = true;
            }
        }
    }

    function handleDoubleClick(event) {
        if (event.target.nodeName === "DIV") {
            if (Number(event.target.innerText)) {
                setIndex(Number(event.target.innerText) - 1);
                setOpen(true);
            }
        }
    }

    const handleCloseSelectArea = () => {
        setIsEdit(false)
        setRefresh((pre) => !pre)
        const selectedAreaDot = document.querySelector(".hidden-dot")
        const selectedAreaConfig = document.querySelector(".select-configuration")
        selectedAreaDot.style.display = "none"
        selectedAreaConfig.style.display = "none"
    }

    const handleEditClickedArea = () => {
        setIsEdit(true)
        const selectedAreaDot = document.querySelector(".hidden-dot")
        const selectedAreaConfig = document.querySelector(".select-configuration")
        const rescaledWidth = document.getElementById("scoped-image").offsetWidth;
        const rescaledHeight = document.getElementById("scoped-image").offsetHeight;
        const selectedArea = document.querySelector(".selected-area")
        selectedAreaConfig.style.display = "inline-block"
        selectedAreaDot.style.display = "none"
        let x = selectedArea.style.left
        let y = selectedArea.style.top
        y = parseInt(y);
        x = parseInt(x);
        if ((rescaledWidth / 5) + x < rescaledWidth) {
            selectedAreaConfig.style.left = x + "px"
        }
        else {
            selectedAreaConfig.style.left = (x - (rescaledWidth / 5)) + selectedArea.offsetWidth + "px"
        }
        if (selectedAreaConfig.offsetHeight + y < rescaledHeight) {
            selectedAreaConfig.style.top = y + selectedArea.offsetHeight + "px"
        }
        else {
            selectedAreaConfig.style.left = (x - (rescaledWidth / 5)) + "px"
            selectedAreaConfig.style.top = (y - selectedAreaConfig.offsetHeight) + selectedArea.offsetHeight + "px"
        }
    }
    const handleDeleteClickedArea = () => {
        setShowSquareHighlight(false)
        setSquareHighlightValues({
            clickObj: [0, 0, 0, 0],
            neighbourObj: [0, 0, 0, 0]
        })
        action.fields.difference = { value: "" };
        action.fields.highlightedElements = { value: { clickedObj: [], neighbourObj: [] } }
        const startDiv = document.getElementById("source-click-div")
        const endDiv = document.getElementById("destination-click-div")
        startDiv.style.display = "none"
        endDiv.style.display = "none"
        setRefresh((pre) => !pre)

    }

    //added  crop
    function changeCoordinate(coordinate, i, coordinates) {
        const limitedAreaProps = refGetTextImage.current.container.getBoundingClientRect()

        if (coordinates[0].x < 0)
            coordinates[0].x = 0;
        if ((coordinates[0].x + coordinates[0].width) > Math.floor(limitedAreaProps.width)) {
            const differWidth = Math.floor(limitedAreaProps.width) - coordinates[0].width;
            coordinates[0].x = differWidth < 0 ? 0 : differWidth;
            coordinates[0].width = Math.floor(limitedAreaProps.width) - coordinates[0].x;
        }
        if (coordinates[0].y < 0)
            coordinates[0].y = 0
        else if ((coordinates[0].y + coordinates[0].height) > Math.floor(limitedAreaProps.height)) {
            const differHeight = (Math.floor(limitedAreaProps.height) - coordinates[0].height);
            coordinates[0].y = differHeight < 0 ? 0 : (Math.floor(limitedAreaProps.height) - coordinates[0].height)
            coordinates[0].height = Math.floor(limitedAreaProps.height) - coordinates[0].y;
        }
        coordinates[0].x = Math.floor(coordinates[0].x);
        coordinates[0].y = Math.floor(coordinates[0].y);
        if (isVariableShow === false && coordinates.length <= 1 && isGetText === false) {
            setImgCoordinate({ coordinates });
            if (isGrid === 0) action.fields.completedCropOffset.value = coordinates;
            else action.fields.gridCrop.value = coordinates;
            setIndex(i);
        } else if (isVariableShow === true && isGetText === false) {
            setImgCoordinate({ coordinates });
            if (isGrid === 0) action.fields.completedCropOffset.value = coordinates;
            else action.fields.gridCrop.value = coordinates;
            setIndex(i);
        } else if (isVariableShow === true && coordinates.length <= 1 && isGetText === true) {
            setImgCoordinate({ coordinates });
            if (isGrid === 0) action.fields.completedCropOffset.value = coordinates;
            else action.fields.gridCrop.value = coordinates;
            setIndex(i);
        }
        setRefresh((pre) => !pre)
    }

    function assignResolution(e) {
        action.fields.resolution.value = { width: e.target.offsetWidth, height: e.target.offsetHeight };
    }

    // deleting crop
    function deleteCoordinate(coordinate, i, coordinates) {
        setImgCoordinate({ coordinates });
        if (action.fields.completedCropOffset) {
            action.fields.completedCropOffset = { value: [] };
        }
        if (action.fields.completedCrop) {
            action.fields.completedCrop = { value: [] };
        }
        if (action.fields.cropImg) {
            action.fields.cropImg = { value: "" };
        }
        if (isVariableShow === false) {
            let sourceDiv = document.getElementById("source-click-div");
            let destinationDiv = document.getElementById("destination-click-div");
            action.fields.source = { value: { x: 0, y: 0 } };
            action.fields.destination = { value: { x: 0, y: 0 } };
            sourceDiv.style.top = "0";
            sourceDiv.style.left = "0";
            destinationDiv.style.top = "0";
            destinationDiv.style.left = "0";
            control = false;
        }
        // if (isFindAndInput === true) {
        //     if (action.fields.inputValue) {
        //         action.fields.inputValue = { value: "" }
        //     }
        // }
        setRefresh(!refresh)
    }

    const changeCoordinateByScale = async () => {
        if ((action.actionName === 'GET-TEXT' || action.actionName === 'CROP-IMAGE' || action.actionName === 'PAGINATION-ITEM') && refGetTextImage && action.fields?.completedCropOffset?.value && action.fields?.completedCropOffset?.value.length) {
            let c = JSON.parse(JSON.stringify(action.fields.completedCropOffset.value))
            const image = new Image();
            image.src = upImg;

            // Scale Configuration
            const originalWidth = image.width;
            const originalHeight = image.height;

            const rescaledWidth = refGetTextImage?.current?.img?.offsetWidth;
            const rescaledHeight = refGetTextImage?.current?.img?.offsetHeight;


            const scaleX = originalWidth / rescaledWidth;
            const scaleY = originalHeight / rescaledHeight;

            const originalX = Math.round(c[0].x * scaleX);
            const originalY = Math.round(c[0].y * scaleY);

            const wth = Math.round(c[0].width * scaleX);
            const height = Math.round(c[0].height * scaleY);

            c[0].x = originalX;
            c[0].y = originalY;
            //

            c[0].width = wth;
            c[0].height = height;

            action.fields.completedCrop.value = c;
            setRefresh((pre) => !pre)
        }
    }

    const resizeNeighbourSquare = (v, image) => {
        if (v[0] < 0 || v[1] < 0) {
            v[0] = v[0] < 0 ? 0 : v[0]
            v[1] = v[1] < 0 ? 0 : v[1]
        }
        if (v[0] + v[2] >= image?.imageWidth || v[1] + v[3] >= image?.imageHeight) {
            v[0] = v[0] + v[2] >= image.imageWidth ? image.imageWidth - v[2] : v[0]
            v[1] = v[1] + v[3] >= image.imageHeight ? image.imageHeight - v[3] : v[1]
            v[2] = v[2] >= image.imageWidth ? image.imageWidth : v[2]
            v[3] = v[3] >= image.imageHeight ? image.imageHeight : v[3]
        }
        setSquareHighlightValues((prev) => ({
            ...prev,
            neighbourObj: v
        }));

        action.fields.highlightedElements.value.neighbourObj = v;
    }
    const resizeClickAreaSquare = (v, image) => {
        if (v[0] < 0 || v[1] < 0) {
            v[0] = v[0] < 0 ? 0 : v[0]
            v[1] = v[1] < 0 ? 0 : v[1]
        }
        if (v[0] + v[2] >= image?.imageWidth || v[1] + v[3] >= image?.imageHeight) {
            v[0] = v[0] + v[2] >= image.imageWidth ? image.imageWidth - v[2] : v[0]
            v[1] = v[1] + v[3] >= image.imageHeight ? image.imageHeight - v[3] : v[1]
            v[2] = v[2] >= image.imageWidth ? image.imageWidth : v[2]
            v[3] = v[3] >= image.imageHeight ? image.imageHeight : v[3]
        }
        setSquareHighlightValues((prev) => ({
            ...prev,
            clickObj: v
        }));

        action.fields.highlightedElements.value.clickedObj = v;
    }

    const showRightAreaOnCenterPage = () => {
        // document click circle and configuration div and give them styles
        const selectedAreaDot = document.querySelector(".hidden-dot")
        const selectedAreaConfig = document.querySelector(".select-configuration")
        selectedAreaConfig.style.display = "inline-block"
        selectedAreaConfig.style.left = "43%"
        selectedAreaConfig.style.top = "30%"
        selectedAreaDot.style.display = "inline-block"
        setRefresh((pre) => !pre)
    }

    const saveNewNeighborSize = async (x, y, width, height) => {
        const image = new Image();
        image.src = upImg;

        const originalWidth = image.width;
        const originalHeight = image.height;

        const rescaledWidth = document.getElementById("scoped-image").offsetWidth;
        const rescaledHeight = document.getElementById("scoped-image").offsetHeight;

        const widthScale = originalWidth / rescaledWidth;
        const heightScale = originalHeight / rescaledHeight;

        let [clickX, clickY, clickWidth, clickHeight] = squareHighlightValues.clickObj


        // resize for clickArea
        const resizedClickedLeft = Math.round(clickX * widthScale);
        const resizedClickedTop = Math.round(clickY * heightScale);
        const resizedClickedWidth = Math.round(clickWidth * widthScale);
        const resizedClickedHeight = Math.round(clickHeight * heightScale);


        // resize for uniqNeigbor
        const resizedLeft1 = Math.round(x * widthScale);
        const resizedTop1 = Math.round(y * heightScale);

        const resizedPartWidth1 = width * widthScale;
        const resizedPartHeight1 = height * heightScale;
        await helper.extractAreaAsBase64FromImage(upImg, resizedLeft1, resizedTop1, resizedPartWidth1, resizedPartHeight1)
            .then(base64CroppedImage => {
                action.fields.cropImg = {
                    byteValue: base64CroppedImage,
                    value: '',
                    extension: '',
                    type: "FILE",
                    fileSize: 0,
                };
            })
        const differenceX = resizedLeft1 - (resizedClickedLeft + (resizedClickedWidth / 2)) //originalX
        const differenceY = resizedTop1 - (resizedClickedTop + (resizedClickedHeight / 2))// originalY
        // const differenceX = resizedLeft1 - (action.fields.highlightedElements.value.clickedObj[0] + (action.fields.highlightedElements.value.clickedObj[3] / 2)) //originalX
        // const differenceY = resizedTop1 - (action.fields.highlightedElements.value.clickedObj[1] + (action.fields.highlightedElements.value.clickedObj[4] / 2))// originalY

        action.fields.difference.value = { x: Math.round(differenceX), y: Math.round(differenceY) };

        const arrowLongX = x - action.fields.highlightedElements.value.clickedObj[0]
        const arrowLongy = y - action.fields.highlightedElements.value.clickedObj[1]
        const startDiv = document.getElementById("source-click-div")
        const endDiv = document.getElementById("destination-click-div")
        if (Math.abs(arrowLongX) > 50 || Math.abs(arrowLongy) > 50) {
            startDiv.style.left = clickX + (clickWidth / 2) + "px"
            startDiv.style.top = clickY + (clickHeight / 2) + "px"
            startDiv.style.display = "block"

            endDiv.style.left = x + "px"
            endDiv.style.top = y + "px"
            endDiv.style.display = "block"
        }
        else {
            startDiv.style.display = "none"
            endDiv.style.display = "none"
        }
        setRefresh((pre) => !pre)
    }


    const saveNewClickedAreaSize = async (x, y, width, height) => {
        const image = new Image();
        image.src = upImg;

        const originalWidth = image.width;
        const originalHeight = image.height;

        const rescaledWidth = document.getElementById("scoped-image").offsetWidth;
        const rescaledHeight = document.getElementById("scoped-image").offsetHeight;

        const widthScale = originalWidth / rescaledWidth;
        const heightScale = originalHeight / rescaledHeight;
        let [neighborX, neighborY] = squareHighlightValues.neighbourObj
        // Neighbor için x ve y hesaplama
        const resizedLeft1 = Math.round(neighborX * widthScale);
        const resizedTop1 = Math.round(neighborY * heightScale);

        // ClickedArea için x,y,width ve height hesaplama
        const resizedClickedLeft = Math.round(x * widthScale);
        const resizedClickedTop = Math.round(y * heightScale);
        const resizedClickedWidth = width * widthScale;
        const resizedClickedHeight = height * heightScale;

        let originalX = resizedClickedLeft + (resizedClickedWidth / 2)
        let originalY = resizedClickedTop + (resizedClickedHeight / 2)
        action.fields.source.value.x = originalX
        action.fields.source.value.y = originalY
        const differenceX = resizedLeft1 - originalX
        const differenceY = resizedTop1 - originalY

        action.fields.difference.value = { x: Math.round(differenceX), y: Math.round(differenceY) };

        if (action.actionName === "ELEMENT-EXIST") {
            await helper.extractAreaAsBase64FromImage(upImg, resizedClickedLeft, resizedClickedTop, resizedClickedWidth, resizedClickedHeight)
                .then(base64CroppedImage => {
                    action.fields.cropImg = {
                        byteValue: base64CroppedImage,
                        value: '',
                        extension: '',
                        type: "FILE",
                        fileSize: 0,
                    };
                })
        }

        // Arrow Hesaplaması
        const arrowLongX = neighborX - x
        const arrowLongy = neighborY - y
        const startDiv = document.getElementById("source-click-div")
        const endDiv = document.getElementById("destination-click-div")
        if (Math.abs(arrowLongX) > 50 || Math.abs(arrowLongy) > 50) {
            startDiv.style.left = x + (width / 2) + "px"
            startDiv.style.top = y + (height / 2) + "px"
            startDiv.style.display = "block"

            endDiv.style.left = neighborX + "px"
            endDiv.style.top = neighborY + "px"
            endDiv.style.display = "block"
        }
        else {
            startDiv.style.display = "none"
            endDiv.style.display = "none"
        }
        setRefresh((pre) => !pre)
    }



    return (
        // <div>
        //     <Dialog
        //         id="autom-addNew-modal"
        //         data-test="autom-add-new"
        //         open={true}
        //         onKeyDown={(e) => handleKeyEvent(e)}
        //         fullScreen={true}
        //         PaperProps={{
        //             style: {
        //                 minWidth: "100%",
        //                 display: "inline-block",
        //             },
        //             id: "capture-area"
        //         }}
        //     >
        //         <DialogTitle id="alert-dialog-title">
        //             <Button
        //                 style={{}}
        //                 data-test="cancelautom-button"
        //                 onClick={() => setOpenCaptureArea(false)}
        //             >
        //                 <Close />
        //             </Button>
        //         </DialogTitle>
        //         <DialogContent style={{ display: "inline-block", padding: "0" }}>
        //             <div style={{ textAlign: "center", display: "inline-block" }}>
        //                 <div
        //                     onClick={(e) => handleClickedOld(e)}
        //                     onDoubleClick={(e) => handleDoubleClick(e)}
        //                     id="popupImg"
        //                 >
        //                     <img
        //                         src={upImg}
        //                         alt="screen shot image"
        //                         style={{ width: '100%' }}
        //                     />
        //                     <div id="source-click-div" ref={refSource} />
        //                     <div id="destination-click-div" ref={refDestination} />
        //                     {showSquareHighlight && (
        //                         <>
        //                             <SquareHighlight x={squareHighlightValues.clickObj[0] - 4}
        //                                 y={squareHighlightValues.clickObj[1] + 67}
        //                                 width={squareHighlightValues.clickObj[2]}
        //                                 height={squareHighlightValues.clickObj[3]}
        //                                 colorCode="red" />
        //                             <SquareHighlight x={squareHighlightValues.neighbourObj[0] - 4}
        //                                 y={squareHighlightValues.neighbourObj[1] + 67}
        //                                 width={squareHighlightValues.neighbourObj[2]}
        //                                 height={squareHighlightValues.neighbourObj[3]}
        //                                 colorCode="green" />
        //                         </>
        //                     )}

        //                     {showElementsHighlight && (
        //                         <>
        //                             <ElementsHighlight data={elementsValue}
        //                                 colorCode="blue" />
        //                         </>
        //                     )}

        //                 </div>
        //             </div>
        //         </DialogContent>
        //         {open && isGrid === 0 && isVariableShow === true && (
        //             <VariableAssign
        //                 index={index}
        //                 imgCoordinate={imgCoordinate}
        //                 setImgCoordinate={setImgCoordinate}
        //                 action={action}
        //                 upImg={upImg}
        //                 setOpenCaptureArea={setOpen}
        //                 setOpenVariable={setOpenVariable}
        //                 variables={variables}
        //             />
        //         )}
        //     </Dialog>
        //     {openInputModal && (
        //         <InputModal
        //             setOpen={setOpenInputModal}
        //             action={action}
        //             setOpenVariable={setOpenVariable}
        //             variables={variables}
        //         />
        //     )}
        // </div>
        <>

            <div id="capture-area-exit-icon" onClick={() => { changeCoordinateByScale(); handleCloseDialog(); }} className="dialog-desktop-actions-exit-icon"><Close /></div>
            <div className="capture-area-content" >
                <div className="find-and-click-image-container" ref={containerAreaRef}>
                    <div
                        // onClick={(e) => handleClicked(e)}
                        // // onClick={(e) => handleClick(e)}
                        // onDoubleClick={(e) => handleDoubleClick(e)}
                        id="popupImg"
                        className={`${imageEnlarged ? "enlarged" : ""} fullscreen-image`}
                        style={handleScale()}
                    >

                        {
                            action.actionName === 'PAGINATION-ITEM' ? (
                                <MultiCrops
                                    id="multi-crop-image"
                                    width="100%"
                                    height="100%"
                                    // onDraw={(e) => handleDraw(e)}
                                    ref={refGetTextImage}
                                    src={upImg}
                                    coordinates={imgCoordinate.coordinates}
                                    onChange={changeCoordinate}
                                    onDelete={deleteCoordinate}
                                    onLoad={assignResolution}
                                />
                            ) :
                                (action.actionName === 'GET-TEXT' || action.actionName === 'CROP-IMAGE') ? (

                                    <MultiCrops
                                        id="multi-crop-image"
                                        width="100%"
                                        height="100%"
                                        // onDraw={(e) => handleDraw(e)}
                                        ref={refGetTextImage}
                                        src={upImg}
                                        coordinates={imgCoordinate.coordinates}
                                        onChange={changeCoordinate}
                                        onDelete={deleteCoordinate}
                                    />

                                ) : (
                                    <img
                                        src={upImg}
                                        alt="screen shot image"
                                        id="scoped-image"
                                        style={{ width: '100%', height: "100%" }}
                                        onClick={(e) => handleClickedArea(e)}
                                        // onClick={(e) => handleClick(e)}
                                        onDoubleClick={(e) => handleDoubleClick(e)}
                                        // onClick={(e) => handleClicked(e)}
                                        draggable={false}
                                    />
                                )
                        }
                        {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete} message={t(label + 'CHANGE-CLICKAREA')} deleteFunc={handleClicked} />}
                        <div id="source-click-div" ref={refSource} style={{ position: "absolute", display: "none" }} />
                        <div id="destination-click-div" ref={refDestination} style={{ position: "absolute", display: "none" }} />
                        {refDestination?.current?.style?.display !== 'none' ? (
                            <Xarrow
                                strokeWidth={2.5}
                                headSize={5}
                                zIndex={500}
                                start={refDestination} //can be react ref
                                end={refSource} //or an id
                            />
                        ) : null}
                        {/* <Dialog
                        id="show-clickible-area"
                        open={true}
                        PaperProps={{
                            style: {
                                height: "80%",
                                width: "80%",
                                position: "relative",
                                overflow: "hidden",
                                backgroundColor: "transparent",
                                maxWidth: "none",
                                marginLeft: "20%",
                                transition: " opacity 0.3s",
                            },
                        }}
                    >
                        {showSquareHighlight && (
                            <>
                                <SquareHighlight x={squareHighlightValues.clickObj[0] - 4}
                                    y={squareHighlightValues.clickObj[1] + 67}
                                    width={squareHighlightValues.clickObj[2]}
                                    height={squareHighlightValues.clickObj[3]}
                                    colorCode="red" />
                                <SquareHighlight x={squareHighlightValues.neighbourObj[0] - 4}
                                    y={squareHighlightValues.neighbourObj[1] + 67}
                                    width={squareHighlightValues.neighbourObj[2]}
                                    height={squareHighlightValues.neighbourObj[3]}
                                    colorCode="green" />
                            </>
                        )}

                        {showElementsHighlight && (
                            <>
                                <ElementsHighlight data={elementsValue}
                                    colorCode="blue" />
                            </>
                        )}
                    </Dialog> */}

                        {showSquareHighlight && (
                            <>
                                <SquareHighlight x={squareHighlightValues.clickObj[0] < 0 ? 0 : squareHighlightValues.clickObj[0]}
                                    y={squareHighlightValues.clickObj[1] < 0 ? 0 : squareHighlightValues.clickObj[1]}
                                    width={squareHighlightValues.clickObj[2]}
                                    height={squareHighlightValues.clickObj[3]}
                                    handleEditClickedArea={handleEditClickedArea}
                                    handleDeleteClickedArea={handleDeleteClickedArea}
                                    isResizable={true}
                                    resize={resizeClickAreaSquare}
                                    saveNewSize={saveNewClickedAreaSize}
                                    handleChangeNeighborArea={handleChangeNeighborArea}
                                    isHover={action.actionName === "HOVER"}
                                    colorCode="red"
                                />
                                <SquareHighlight x={squareHighlightValues.neighbourObj[0] < 0 ? 0 : squareHighlightValues.neighbourObj[0]}
                                    y={squareHighlightValues.neighbourObj[1] < 0 ? 0 : squareHighlightValues.neighbourObj[1]}
                                    width={squareHighlightValues.neighbourObj[2]}
                                    height={squareHighlightValues.neighbourObj[3]}
                                    resize={resizeNeighbourSquare}
                                    isResizable={true}
                                    saveNewSize={saveNewNeighborSize}
                                    handleChangeClickArea={handleChangeClickArea}
                                    colorCode="green" />
                            </>
                        )}

                        {openRunningModal && (
                            <RunningModal
                                flowStatus={flowStatus}
                                setOpen={setOpenRunningModal}
                                setFlowStatus={setFlowStatus}
                                errorMessage={""}
                                operationId={operationId}
                                // mateId={undefined}
                                isDesktopRecorder={true}
                                label={label}
                            />
                        )}

                        {showElementsHighlight && (
                            <>
                                <ElementsHighlight data={elementsValue} setOpenHighlightModal={setOpenHighlightModal} handleClickedArea={handleClickedArea}
                                    showSquareHighlight={showSquareHighlight} handleChangeClickArea={handleChangeClickArea}
                                    handleChangeNeighborArea={handleChangeNeighborArea}
                                    colorCode="blue" />
                            </>
                        )}
                        {/* {openHighlightModal && (
                            <HighlightAreaConfiguration
                                setOpen={setOpenHighlightModal}
                                label={label}
                            />
                        )} */}
                        {/* {hiddenDot && <div className="hidden-dot" style={{ width: "10px", height: "10px", borderRadius: "10px", backgroundColor: "red", left: "1241px", top: "96px", position: "absolute" }}></div>} */}

                        <div className="hidden-dot">
                            <div className="small-hidden-dot"></div>
                        </div>
                        <div className="select-configuration" style={{ minWidth: action.actionName === "HOVER" || action.actionName === "SMOOTH-SCROLL" && "170px" }}>
                            {!["GET-TEXT", "CROP-IMAGE", 'PAGINATION-ITEM'].includes(action.actionName) && <Close className="close-edit-button" onClick={handleCloseSelectArea} />}
                            <RightArea
                                automDetail={automDetail}
                                setAutomDetail={setAutomDetail}
                                actions={actions}
                                selectedAction={action}
                                variables={variables}
                                setVariables={setVariables}
                                setOpenVariable={setOpenVariable}
                                recorder={recorder}
                                drecorder={drecorder}
                                fromFlow={false}
                                getVariables={getVariables}
                                outputVisible={true}
                                setField={() => handleSave()}
                            />
                        </div>

                    </div>
                </div>
                {
                    open && isGrid === 0 && isVariableShow === true && (
                        <VariableAssign
                            index={index}
                            imgCoordinate={imgCoordinate}
                            setImgCoordinate={setImgCoordinate}
                            action={action}
                            upImg={upImg}
                            setOpenCaptureArea={setOpen}
                            setOpenVariable={setOpenVariable}
                            variables={variables}
                        />
                    )
                }
            </div >
            <Guide
                isClick={["FIND-AND-CLICK", "FIND-AND-INPUT", "HOVER", "ELEMENT-EXIST", "PAGINATION", "SMOOTH-SCROLL"].includes(action?.actionName)}
                // action={action}
                // isConfiguration={document.querySelector(".hidden-dot")?.style?.display === "none" ? false : true}
                isShowSquareHighlight={showSquareHighlight}
                isDrawArea={imgCoordinate.coordinates.length > 0}
                isScope={false}
                refresh={refresh}
            />
            {/* <div className="helper-container">
                <h2>Guide</h2>

                <span> - Click on an area to define your click area.</span>
            </div> */}
        </>


    );
};

export default CaptureArea;